module.exports = __webpack_public_path__ + "img/5.80868743.jpg";